import React from 'react';
import { useNavigate } from 'react-router-dom';

const EmptyProjectsState = ({onNewProjectClick}) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center bg-white rounded-lg shadow-md p-10 my-8 max-w-3xl mx-auto text-center">
      <div className="w-32 h-32 mb-6 flex items-center justify-center rounded-full bg-gray-100">
        <svg 
          className="w-16 h-16 text-gray-400" 
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={1.5} 
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" 
          />
        </svg>
      </div>

      <h2 className="text-2xl font-semibold text-gray-800 mb-2">No Projects Found</h2>
      <p className="text-gray-500 mb-8 max-w-md">
        You haven't created any projects yet. Start by creating your first project to track construction progress and collaborate with your team.
      </p>
      
      <button
        // onClick={() => navigate('/create-site')}
        className="px-6 py-3 bg-[#3B0069] text-white rounded-lg font-medium transition-all hover:bg-[#4B0089] transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50"
      >
        <div className="flex items-center space-x-2" onClick={onNewProjectClick}>
          <svg 
            className="w-5 h-5" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 6v6m0 0v6m0-6h6m-6 0H6" 
            />
          </svg>
          <span>Create New Project</span>
        </div>
      </button>
    </div>
  );
};

export default EmptyProjectsState;